<style>
@import '../../assets/css/tool.css';
</style>

<template>
    <div class="main-panel" v-if="ajaxLoad === true">
        <div class="main-content">
            <div class="container-fluid">
                <b-card class="mt-3">
                    <b-button variant="primary" class="mb-3 float-right" @click="getAddSystemPayment()" v-if="permissionList.includes(permission.add)"><font-awesome-icon icon="plus"/> {{$t('setting_systempayment.table_add')}}</b-button>
                    <el-table class="custom-table" :data="ajaxTable" @expand-change="expandChange" @row-click="expandRow" ref="tableTest" border>
                        <el-table-column v-for="title in titles" :prop="title.prop" :label="title.label" :key="title.prop" :min-width="title.width">
                            <template slot="header">
                                <p>{{title.label}}</p>
                                <b-form-input :placeholder="title.label" @keyup.enter="initialize()" v-model="ajaxSearch[title.prop]"></b-form-input>
                            </template>
                        </el-table-column>
                        <el-table-column type="expand">
                            <b-button variant="info" size="lg" @click="getEditSystemPayment()" v-if="permissionList.includes(permission.edit)">{{$t('setting_systempayment.table_edit')}}</b-button>
                            <b-button variant="danger" size="lg" class="ml-1" @click="deleteSystemPayment()" v-if="permissionList.includes(permission.delete)">{{$t('setting_systempayment.table_delete')}}</b-button>
                        </el-table-column>
                    </el-table>
                    <b-row class="mt-3">
                        <b-col sm="12" md="3" class="pr-0">
                            <span class="float-left">{{$t('admin.table_show_result',{result:ajaxTool.total_number})}}</span>
                        </b-col>
                        <b-col sm="12" md="9" class="pl-0">
                            <el-pagination class="text-right" layout="sizes,prev, pager, next" @size-change="paginationSizeChange" @current-change="paginationCurrentChange" :current-page.sync="ajaxTool.current_pagination" :total="ajaxTool.total_number" :hide-on-single-page="1" :page-sizes="[10, 30, 50, 100]" :page-size="10" background></el-pagination>
                        </b-col>
                    </b-row>
                </b-card>
                
                <b-modal id="addSystemPayment" :title="$t('setting_systempayment.table_add')" size="lg" @ok="addSystemPayment" :cancelTitle="$t('button.close')" :okTitle="$t('button.submit')">
                    <form id="addSystemPaymentForm" @submit.prevent="addSystemPayment">
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('setting_systempayment.table_status')}}</template>
                            <b-form-select name="status_id" v-model="ajaxAdd.statusShow">
                                <option v-for="(statusList,index) in ajaxAdd.status_list" :key="index" :value="statusList.id">{{statusList.code}} ({{statusList.name}})</option>
                            </b-form-select>
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="4" class="mb-0">
                            <template slot="label">{{$t('setting_systempayment.table_radio')}}</template>
                        </b-form-group>
                        <div class="custom-from-group">
                            <b-form-group label-cols="12" label-cols-lg="4" v-for="(walletList,index) in ajaxAdd.wallet_list" :key="index" name="wallet[]">
                                <template slot="label">{{walletList.code}}</template>
                                <b-form-input :name="'formula[' + walletList.id + ']'" value="0"></b-form-input>
                            </b-form-group>
                        </div>
                    </form>
                </b-modal>
                <b-modal id="editSystemPayment" :title="$t('setting_systempayment.table_edit')" size="lg" @ok="editSystemPayment" :cancelTitle="$t('button.close')" :okTitle="$t('button.submit')">
                    <form id="editSystemPaymentForm" @submit.prevent="editSystemPayment">
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('setting_systempayment.table_status')}}</template>
                            <b-form-select name="status_id" v-model="ajaxEdit.status_id">
                                <option v-for="(statusList,index) in ajaxEdit.status_list" :key="index" :value="statusList.id">{{statusList.code}} ({{statusList.name}})</option>
                            </b-form-select>
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="4" class="mb-0">
                            <template slot="label">{{$t('setting_systempayment.table_radio')}}</template>
                        </b-form-group>
                        <div class="custom-from-group">
                            <b-form-group label-cols="12" label-cols-lg="4" v-for="(walletList,index) in ajaxEdit.wallet_list" :key="index" name="wallet[]">
                                <template slot="label">{{walletList.code}}</template>
                                <b-form-input :name="'formula[' + walletList.id + ']'" :value="walletList.value"></b-form-input>
                            </b-form-group>
                        </div>
                    </form>
                </b-modal>
            </div>
        </div>
    </div>
</template>

<script>
import {languageList,systemPaymentAjaxTable,getSystemPaymentAdd,systemPaymentAdd,getSystemPaymentEdit,systemPaymentEdit,systemPaymentDelete,systemPaymentCheckPackage} from '@/system/model/tools'
import {removeTokenByName} from '@/system/store/cookie';
import {getSessionStorage,setSessionStorage } from '@/system/store/sessionstorage';
import {setLocalStorage, getLocalStorage} from '@/system/store/localstorage';

export default {
    inject:['preloader'],
    data(){
        return{   
            ajaxLoad:false,
            validate:true,
            ajaxTable:[],
            ajaxTool:[],
            ajaxSearch:{limit:'',pagination:'',id:'',status_id:''},
            ajaxAdd:{statusShow:''},
            ajaxEdit:{status_list:[],wallet_list:[]},
            ajaxRow:'',
            csrfName:'',
            csrfValue:'',
            csrfNameKey:'',
            csrfValueKey:'',
            pageLimit:10,
            errors: [],
            permission:{
                add:'9E7392',
                edit:'2777CC',
                delete:'B8A38C'
            },
            permissionList:[],
            titles:[{
                prop: "id",
                label: this.$t('setting_systempayment.table_id'),
                width: '147'
            },{
                prop: "status_id",
                label: this.$t('setting_systempayment.table_status'),
                width: '217'
            },{
                prop: "formula",
                label: this.$t('setting_systempayment.table_formula'),
                width: '217'
            }], 
        }
    },methods:{
        initialize(){
            var self = this;
            var result = systemPaymentAjaxTable(this.ajaxSearch.limit,this.ajaxSearch.pagination,this.ajaxSearch.id,this.ajaxSearch.status_id);
            this.preloader(true);
            result.then(function(value){
                self.preloader(false);
                if(value.valid){
                    self.ajaxLoad = true;
                    self.ajaxTable = value.data.datatable.data;
                    self.ajaxTool = value.data.datatable;
                    self.csrfName = value.data.csrf_list.csrf_name;
                    self.csrfValue = value.data.csrf_list.csrf_value;
                    self.csrfNameKey = value.data.csrf_list.csrf_name_key;
                    self.csrfValueKey = value.data.csrf_list.csrf_value_key;
                    self.permissionList = JSON.parse(getLocalStorage('permission_list'));
                }else{
                    self.$swal.fire({
                        type: 'error',
                        html: self.$t('login.error_relogin'),
                        onClose: () => {
                            removeTokenByName('auth_sign_token');
                            self.$router.push('/');
                        }
                    });		
                }
            });
        },getAddSystemPayment(){
            if(this.permissionList.includes(this.permission.add)){
                var self = this;
                var result = getSystemPaymentAdd();
                this.preloader(true);
                result.then(function(value){
                    self.preloader(false);
                    if(value.valid){
                        self.$bvModal.show('addSystemPayment');
                        self.ajaxAdd = value.data;
                        self.ajaxAdd.statusShow = self.ajaxAdd.status_list[0].id;
                    }
                });
            }
        },addSystemPayment(){
            if(this.permissionList.includes(this.permission.add)){
                var self = this;
                this.preloader(true);
                this.errors = [];
                if(this.validate){
                    var form = document.getElementById('addSystemPaymentForm');
                    var formData = new FormData(form);
                    formData.append(this.csrfNameKey, this.csrfName); 
                    formData.append(this.csrfValueKey, this.csrfValue);  
                    var result = systemPaymentAdd(formData);
                    result.then(function(value){
                        self.preloader(false);
                        if(value.valid){
                            self.$swal.fire({
                                type: 'success',
                                text: self.$t(value.returnMsg),
                                onClose: () => {
                                    self.initialize();            
                                }
                            });
                        }else{
                            var text = "";
                            if(Array.isArray(value.returnMsg)){
                                value.returnMsg.forEach(function (value) {
                                    text += self.$t(value)+"<br />";
                                }); 
                            }else{
                                text = self.$t(value.returnMsg);
                            }

                            self.$swal.fire({
                                type: 'error',
                                html: text,
                                onClose: () => {
                                    self.initialize();            
                                }
                            });
                        }
                    });    
                }else{
                    this.validate = true;
                    this.preloader(false);
                    var text = "";
                    this.errors.forEach(function (value) {
                        text += self.$t(value)+"<br />";
                    }); 
                    
                    this.$swal.fire({
                        type: 'error',
                        html: text
                    });
                }  
            }       
        },getEditSystemPayment(){
            if(this.permissionList.includes(this.permission.edit)){
                var self = this;
                var result = getSystemPaymentEdit(this.ajaxRow);
                this.preloader(true);
                result.then(function(value){
                    self.preloader(false);
                    if(value.valid){
                        self.$bvModal.show('editSystemPayment');
                        self.ajaxEdit = value.data.this_detail;
                        self.ajaxEdit.status_list = value.data.status_list;
                        self.ajaxEdit.wallet_list = value.data.wallet_list;
                    }else{
                        var text = "";
                        self.errors.forEach(function (value) {
                            text += self.$t(value)+"<br />";
                        }); 
                        
                        self.$swal.fire({
                            type: 'error',
                            html: text
                        });
                    }
                })
            }
        },editSystemPayment(){
            if(this.permissionList.includes(this.permission.edit)){
                var self = this;
                this.preloader(true);
                if(this.validate){
                    var form = document.getElementById('editSystemPaymentForm');
                    var formData = new FormData(form);
                    formData.append(this.csrfNameKey, this.csrfName); 
                    formData.append(this.csrfValueKey, this.csrfValue); 
                    formData.append('id', this.ajaxEdit.id); 
                    var result = systemPaymentEdit(formData);
                    result.then(function(value){
                        self.preloader(false);
                        if(value.valid){
                            self.$swal.fire({
                                type: 'success',
                                text: self.$t(value.returnMsg),
                                onClose: () => {
                                    self.initialize();            
                                }
                            });
                        }else{
                            var text = "";
                            if(Array.isArray(value.returnMsg)){
                                value.returnMsg.forEach(function (value) {
                                    text += self.$t(value)+"<br />";
                                }); 
                            }else{
                                text = self.$t(value.returnMsg);
                            }

                            self.$swal.fire({
                                type: 'error',
                                html: text,
                                onClose: () => {
                                    self.initialize();            
                                }
                            });
                        }
                    })
                }else{
                    this.validate = true;
                    this.preloader(false);
                    var text = "";
                    this.errors.forEach(function (value) {
                        text += self.$t(value)+"<br />";
                    }); 
                
                    this.$swal.fire({
                        type: 'error',
                        html: text
                    });
                } 
            }
        },deleteSystemPayment(){
            if(this.permissionList.includes(this.permission.delete)){
                this.$swal.fire({
                text: this.$t('msg.confirm_delete'),
                type: 'info',
                showCancelButton: true,
                confirmButtonText: this.$t('button.confirm'),
                cancelButtonText: this.$t('button.cancel'),
                }).then((result)=>{
                    if(result.value){
                        var self = this;
                        self.preloader(true);
                        var formData = new FormData();
                        formData.append(this.csrfNameKey, this.csrfName); 
                        formData.append(this.csrfValueKey, this.csrfValue); 
                        formData.append('id', this.ajaxRow); 
                        var result = systemPaymentDelete(formData);		
                        result.then(function(value){
                            self.preloader(false);
                            if(value.valid){
                                self.$swal.fire({
                                    type: 'success',
                                    text: self.$t(value.returnMsg),
                                    onClose: () => {
                                        self.initialize();            
                                    }
                                });
                            }else{
                                self.preloader(false);
                                var text = "";
                                if(Array.isArray(value.returnMsg)){
                                    value.returnMsg.forEach(function (value) {
                                        text += self.$t(value)+"<br />";
                                    }); 
                                }else{
                                    text = self.$t(value.returnMsg);
                                }

                                self.$swal.fire({
                                    type: 'error',
                                    html: text,
                                    onClose: () => {
                                        self.initialize();            
                                    }
                                });
                            }
                        });
                    }
                });
            }
        },expandRow(row){
            this.$refs.tableTest.toggleRowExpansion(row);
            this.ajaxRow = row.id
        },expandChange(row,expandedRows){
            if(expandedRows.length>1){
                expandedRows.shift()
            }
        },paginationSizeChange(limit){
            this.ajaxSearch.limit = limit;
            this.initialize();
        },paginationCurrentChange(pagination){
            this.ajaxSearch.pagination = pagination;
            this.initialize();
        }
    },created(){
        this.preloader(false);
        this.initialize();
    }
}
</script>
